export default __webpack_public_path__ + "static/media/rewards-bg.30c09666.png";